import type { SVGProps } from "react";

export function OpenMenu(props: SVGProps<SVGSVGElement>) {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="clamp(1.5rem, 1.143rem + 0.952vw, 2rem)"
        height="clamp(1.5rem, 1.143rem + 0.952vw, 2rem)"
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          fill="rgb(255, 252, 252)"
          d="M3 6h18v2H3zm0 5h18v2H3zm0 5h18v2H3z"
        ></path>
      </svg>
    </div>
  );
}
